import { InputTextField } from '@carboncopyco/ui';

export const WELCOME_MAT_TITLE_MAX_LENGTH = 60;

export const WelcomeMatTitleField = () => {
  return (
    <InputTextField
      required
      label="Cover page title"
      name="welcomeMatTitle"
      className="w-full p-0"
      inputSize="lg"
    />
  );
};
